<script lang="ts">

    import Svg from "./common/Svg.svelte";
    import type {SearchQuery, SearchResponse} from "./NvbsSearchEngineApi/interfaces";
    import NumberDisplay from "./common/NumberDisplay.svelte";

    let {
        searchStore = $bindable(),
        searchResults,
        loading = false,
        hideAmount = false,
    }: {
        searchStore: SearchQuery;
        searchResults: SearchResponse | null;
        hideAmount?: boolean;
        loading?: boolean;
    } = $props();

    function prev() {
        scrollToTop();
        if(!searchStore.page) {
            searchStore.page = 1;
        } else if (searchStore.page > 1) {
            searchStore.page -= 1;
        } else {
            searchStore.page = 1;
        }
    }

    function next() {
        scrollToTop();
        if(!searchStore.page) {
            searchStore.page = 1;
        } else if (searchStore.page < searchResults?.totalPages!) {
            searchStore.page += 1;
        } else {
            searchStore.page = searchResults?.totalPages;
        }
    }

    function limitChanged() {
        searchStore.page = 1
    }

    function scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }
</script>

<div class="search-results">
    <div class="result-header">
        {#if !hideAmount}
           <NumberDisplay number={searchResults ? searchResults.totalHits: 0} />  Zoekresultaten gevonden
        {/if}
    </div>

    <div class="pagination">
        <label class="amount-per-page">
            Resultaten per pagina
            <select bind:value={searchStore.limit} onchange={limitChanged}>
                <option selected value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
            </select>
        </label>

        <div class="pagination-items">
            {#if searchStore.page}
                <button
                        class="page-button"
                        onclick={prev}
                        aria-label="Vorige pagina"
                        disabled={searchStore.page === 1 || loading}
                >
                    <Svg type="chevron-left"/>
                </button>
            {/if}
            <input bind:value={searchStore.page} class="page-input" type="number" min="0"
                   max="{searchResults ? searchResults.totalPages : 100000000}"
                   disabled={loading}
            />
            <span>/</span>
            <span><NumberDisplay number={searchResults ? searchResults.totalPages : 0} /></span>
            {#if searchStore.page && searchResults?.totalPages }
                <button
                        class="page-button"
                        onclick={next}
                        aria-label="Volgende pagina"
                        disabled={searchStore.page >= searchResults.totalPages || loading}
                >
                    <Svg type="chevron-right"/>
                </button>
            {/if}
        </div>


    </div>
</div>


<style lang="scss">


  .search-results {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;

    select {
      height: 25px;
      padding-left: 3px;
    }

    .pagination-items {
      display: flex;
      gap: 10px;
    }


    .pagination {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      button.page-button {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0 5px;
        margin: 0;

        &:disabled {
          cursor: not-allowed;
        }
      }

      .page-input {
        width: 75px;
        height: 25px;
        padding-left: 3px;
      }
    }
  }

  // on smaller devices
  @media (max-width: 768px) {
    .search-results {
      flex-direction: column;
      align-items: flex-start;
    }
  }



</style>
